import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import MediaTypography from 'components/MediaTypography';

import { VisaulGuideStepItemType } from '../../types';
import { StepItemWrapper, StyledImage, StyledStepNumber, StyledMediaTypography } from './styled';

function StepItem({ step, title, imageSrc, altImageName, styleProps }: VisaulGuideStepItemType) {
	const { t } = useTranslation();

	return (
		<StepItemWrapper mainColor={styleProps.borderColor}>
			<StyledStepNumber mainColor={styleProps.borderColor}>
				<MediaTypography variant="h4">{step + 1}</MediaTypography>
			</StyledStepNumber>
			<StyledMediaTypography color="#333" variant="subtitle3">
				{t(title)}
			</StyledMediaTypography>
			<Box
				sx={{
					maxHeight: '100%',
					overflow: 'hidden',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<StyledImage src={imageSrc} alt={altImageName} />
			</Box>
		</StepItemWrapper>
	);
}

export default StepItem;
